import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { store } from "redux_store/configureReduxStore";

import { RootState } from "gyg_common";
import useCreateUpdateOrder from "gyg_common/hooks/useCreateUpdateOrder";

const OrderContainerLifeCycle: React.FC = () => {
  const { getOrderLoading, getOrderResponse } = useSelector(
    (s: RootState) => s.order
  );
  const { pathname } = useLocation();
  const { createOrder } = useCreateUpdateOrder(store, pathname, false);

  //
  // Place an order if the site has loaded items into the cart from storage.
  //
  useEffect(() => {
    if (!getOrderResponse && !getOrderLoading) {
      createOrder();
    }
  }, [getOrderResponse, getOrderLoading, createOrder]);

  return <></>;
};
export default OrderContainerLifeCycle;
